import React, { useEffect, useState } from "react";
import { Button } from "../ui/Button";
import RichTextEditor from "../ui/RichTextEditor";

// Criar/editar artigo da Base de Conhecimento.
const ArticleEditorModal = ({ isOpen, onClose, article, onSubmit }) => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [tags, setTags] = useState("");
  const [statusPub, setStatusPub] = useState("rascunho");
  const [isPublic, setIsPublic] = useState(false);
  const [body, setBody] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTitle(article?.title || "");
      setCategory(article?.category || "");
      setTags(article?.tags || "");
      setStatusPub(article?.status || "rascunho");
      setIsPublic(!!article?.is_public);
      setBody(article?.body || "");
      setSaving(false);
    }
  }, [isOpen, article]);

  if (!isOpen) return null;

  const handleSave = async () => {
    if (!title.trim()) {
      alert("Informe um título.");
      return;
    }
    setSaving(true);
    try {
      await onSubmit({
        title: title.trim(),
        category: category.trim() || null,
        tags: tags.trim() || null,
        status: statusPub,
        is_public: isPublic,
        body,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-3xl max-h-[94vh] overflow-y-auto rounded-xl bg-white p-6 shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-900">
            {article?.id ? "Editar artigo" : "Novo artigo"}
          </h2>
          <Button variant="ghost" size="icon" onClick={onClose} aria-label="Fechar">✕</Button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Título</label>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Ex.: Como resetar a senha do e-mail"
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700">Categoria</label>
              <input
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                placeholder="Ex.: Acessos, E-mail, Hardware"
                className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700">Tags (separadas por vírgula)</label>
              <input
                value={tags}
                onChange={(e) => setTags(e.target.value)}
                placeholder="senha, outlook, vpn"
                className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700">Conteúdo</label>
            <div className="mt-1">
              <RichTextEditor value={body} onChange={setBody} />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700">Status</label>
              <select
                value={statusPub}
                onChange={(e) => setStatusPub(e.target.value)}
                className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="rascunho">Rascunho (não aparece na lista publicada)</option>
                <option value="publicado">Publicado</option>
              </select>
            </div>
            <div className="flex items-end">
              <label className="flex items-center gap-2 text-sm text-gray-700">
                <input type="checkbox" checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} className="h-4 w-4" />
                Disponível para base pública (futuro)
              </label>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={saving}>Cancelar</Button>
          <Button onClick={handleSave} disabled={saving}>
            {saving ? "Salvando..." : "Salvar artigo"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ArticleEditorModal;
